{
  "auth": {
    "agree": "我同意",
    "createAccount": "建立帳號",
    "createNewAccount": "建立新帳號",
    "email": "電子郵件",
    "login": "登入",
    "password": "密碼",
    "recover_password": "重設密碼",
    "reset_password": "重設密碼",
    "sign_up": "註冊",
    "keep_logged_in": "保持登入",
    "termsOfUse": "使用條款"
  },
  "404": {
    "title": "找不到此頁面",
    "text": "如果您認為這是錯誤，請聯絡我們",
    "back_button": "返回儀表板"
  },
  "menu": {
    "operations": "營運管理",
    "catalog": "商品資料",
    "system": "系統管理",
    "dashboard": "儀表板",
    "preferences": "帳戶資訊",
    "settings": "介面設定",
    "users": "使用者管理",
    "products": "商品管理",
    "product-mappings": "商品對應管理",
    "orders": "訂單管理",
    "email-template": "電子郵件模板"
  },
  "user": {
    "logout": "登出",
    "profile": "帳戶資訊",
    "settings": "介面設定",
    "account": "帳戶",
    "explore": "連結",
    "shopline": "前台網站"
  },
  "search": {
    "placeholder": "搜尋..."
  },
  "buttonSelect": {
    "dark": "深色",
    "light": "淺色"
  },
  "vuestic": {
    "search": "搜尋",
    "noOptions": "找不到項目",
    "ok": "確定",
    "cancel": "取消",
    "uploadFile": "上傳檔案",
    "undo": "復原",
    "dropzone": "將檔案拖曳至此處上傳",
    "fileDeleted": "檔案已刪除",
    "closeAlert": "關閉警告",
    "backToTop": "回到頂部",
    "toggleDropdown": "切換下拉選單",
    "carousel": "輪播",
    "goPreviousSlide": "上一張投影片",
    "goNextSlide": "下一張投影片",
    "goSlide": "前往第 {index} 張投影片",
    "slideOf": "第 {index} 張，共 {length} 張",
    "close": "關閉",
    "openColorPicker": "開啟顏色選擇器",
    "colorSelection": "顏色選擇",
    "colorName": "顏色 {color}",
    "decreaseCounter": "減少計數",
    "increaseCounter": "增加計數",
    "selectAllRows": "選擇所有列",
    "sortColumnBy": "依 {name} 排序",
    "selectRowByIndex": "選擇第 {index} 列",
    "resetDate": "重設日期",
    "nextPeriod": "下一期間",
    "switchView": "切換檢視",
    "previousPeriod": "上一期間",
    "removeFile": "移除檔案",
    "reset": "重設",
    "pagination": "分頁",
    "goToTheFirstPage": "前往第一頁",
    "goToPreviousPage": "前往上一頁",
    "goToSpecificPage": "前往第 {page} 頁",
    "goToSpecificPageInput": "輸入頁碼以跳轉",
    "goNextPage": "前往下一頁",
    "goLastPage": "前往最後一頁",
    "currentRating": "目前評分 {value} / {max}",
    "voteRating": "評分 {value} / {max}",
    "optionsFilter": "選項篩選",
    "splitPanels": "分割面板",
    "movePaginationLeft": "分頁向左移動",
    "movePaginationRight": "分頁向右移動",
    "resetTime": "重設時間",
    "closeToast": "關閉提示",
    "selectedOption": "已選選項",
    "noSelectedOption": "未選擇選項",
    "breadcrumbs": "導覽列",
    "counterValue": "計數值",
    "selectedDate": "選擇的日期",
    "selectedTime": "選擇的時間",
    "progressState": "進度狀態",
    "color": "顏色",
    "next": "下一步",
    "back": "上一步",
    "finish": "完成",
    "step": "步驟",
    "progress": "進度",
    "loading": "載入中",
    "sliderValue": "目前滑桿值為 {value}",
    "switch": "切換",
    "inputField": "輸入欄位",
    "fileTypeIncorrect": "檔案類型不正確",
    "select": "選擇一個選項"
  }
}
